
/* eslint-disable max-classes-per-file */
import { ObjectUtils } from "~app/common/utils/object-utils";
import {
    AtgardStatusesDTO,
    VKAtgardStatusAvverkningsanmalanDTO,
    VKAtgardStatusExtraKartinfoDTO,
    VKAtgardStatusNaturvardesbedomningDTO
} from "../../dto/atgardstatuses/atgardstatuses";
import { VKAtgardKoppladAtgardDTO } from "../atgard-models";

export class AtgardStatuses {
    statustyp: string;
    atgardGUID: string;
    atgardstyp: string;
    affarsform: string;
    nvBedomningUtfordDatum: string;
    larmPunkterCount: number;
    avlaggCount: number;
    avlaggAllTillganglighetsklass: boolean;
    kojplatserCount: number;
    foreslagetProduktionsdatumFrom: string;
    foreslagetProduktionsdatumTom: string;
    koppladeAtgarder: AtgardStatusKoppladAtgard[];
    naturvardesbedomning: AtgardStatusNaturvardesbedomning;
    naturvardesbedomningDatumLegacy: string;
    extraKartinfo: AtgardStatusExtraKartinfo;
    avverkningsanmalan: AtgardStatusAvverkningsanmalan;

    constructor(dto: AtgardStatusesDTO) {
        this.affarsform = dto.affarsform;
        this.atgardGUID = dto.atgardGUID;
        this.atgardstyp = dto.atgardstyp;
        this.avlaggCount = dto.avlaggCount;
        this.avlaggAllTillganglighetsklass = dto.avlaggAllTillganglighetsklass;
        this.kojplatserCount = dto.kojplatserCount;
        this.foreslagetProduktionsdatumFrom = dto.foreslagetProduktionsdatumFrom;
        this.foreslagetProduktionsdatumTom = dto.foreslagetProduktionsdatumTom;
        this.koppladeAtgarder = dto.koppladeAtgarder?.map(kp => new AtgardStatusKoppladAtgard(kp));
        this.larmPunkterCount = dto.larmPunkterCount;
        this.naturvardesbedomningDatumLegacy = dto.naturvardesbedomningDatumLegacy;
        this.naturvardesbedomning = new AtgardStatusNaturvardesbedomning(dto.naturvardesbedomning);
        this.extraKartinfo = new AtgardStatusExtraKartinfo(dto.extraKartinfo);
        this.avverkningsanmalan = new AtgardStatusAvverkningsanmalan(dto.avverkningsanmalan);
    }
}

export class AtgardStatusNaturvardesbedomning {

    nvbKravsEj?: boolean;
    utfordAv?: string;
    utfordDatum?: string;

    constructor(dto: VKAtgardStatusNaturvardesbedomningDTO) {
        if (ObjectUtils.isNullOrUndefined(dto)) {
            return;
        }
        this.nvbKravsEj = dto.nvbKravsEj;
        this.utfordAv = dto.utfordAv;
        this.utfordDatum = dto.utfordDatum;
    }
}

export class AtgardStatusExtraKartinfo {
    renskotselOmraden?: string;
    rennaringAretRunt?: boolean;
    fjallnara?: boolean;
    iflOmrade?: boolean;

    constructor(dto: VKAtgardStatusExtraKartinfoDTO) {
        if (ObjectUtils.isNullOrUndefined(dto)) {
            return;
        }
        this.rennaringAretRunt = dto.rennaringAretRunt;
        this.fjallnara = dto.fjallnara;
        this.iflOmrade = dto.iflOmrade;
        this.renskotselOmraden = dto.renskotselOmraden;
    }
}

export class AtgardStatusKoppladAtgard {
    avtalId?: number;
    kontraktId?: number;
    atgardId?: number;
    atgardGUID?: string;
    beteckning?: string;
    atgardsgrupp?: string;
    atgardstyp?: string;

    constructor(dto: VKAtgardKoppladAtgardDTO) {
        if (ObjectUtils.isNullOrUndefined(dto)) {
            return;
        }
        this.avtalId = dto.avtalId;
        this.kontraktId = dto.kontraktId;
        this.atgardId = dto.atgardId;
        this.atgardGUID = dto.atgardGuid;
        this.beteckning = dto.beteckning;
        this.atgardsgrupp = dto.atgardsgrupp;
        this.atgardstyp = dto.atgardstyp;
    }
}

export class AtgardStatusAvverkningsanmalan {
    giltigtTillDatum?: string;
    godkantDatum?: string;
    avverkningsanmalanTyp?: string;
    utfordDatum?: string;
    farStartaDatum?: string;

    constructor(dto: VKAtgardStatusAvverkningsanmalanDTO) {
        if (ObjectUtils.isNullOrUndefined(dto)) {
            return;
        }
        this.avverkningsanmalanTyp = dto.avverkningsanmalanTyp;
        this.godkantDatum = dto.godkantDatum;
        this.giltigtTillDatum = dto.giltigtTillDatum;
        this.utfordDatum = dto.utfordDatum;
        this.farStartaDatum = dto.farStartaDatum;
    }
}
